import { render } from "./DomainProject.vue?vue&type=template&id=9aaf52a8"
import script from "./DomainProject.vue?vue&type=script&lang=js"
export * from "./DomainProject.vue?vue&type=script&lang=js"

import "./DomainProject.vue?vue&type=style&index=0&id=9aaf52a8&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__